import { render, staticRenderFns } from "./ItemDetailSubjectLayout.vue?vue&type=template&id=a03320ac&scoped=true"
import script from "./ItemDetailSubjectLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailSubjectLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03320ac",
  null
  
)

export default component.exports